// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3hK1w","column":"style_column__5MWk5"};